<template>
	<div class="cardList">
		<div class="content" :class="{'readOnly':readOnly}">
			<div class="list">
				<div v-for="(item,index) in list" :key="index" class="li">
					<div class="title">{{index+1}}、【{{item.name || item.questionType}}】</div>
					<!-- 其他 -->
					<div class="d-flex d-flex-middle d-flex-wrap">
						<div v-for="(v,i) in item.questions" :key="'i'+i" @click="go(v.id)">
							<div class="div click" :class="setClass(v.id,v.score)" @click="visit(index)" v-if="readOnly">{{i+1}}</div>
							<template v-else>
								<div class="div click" :class="{'on': haveVal(v)}" v-if="v.type == 'TT'" @click="visit(index)">{{i+1}}</div>
								<div class="div click" :class="{'on': haveValue(v.myAnswer)}" v-else-if="v.type == 'BLANKFILL'" @click="visit(index)">{{i+1}}</div>
								<div v-else class="div click" :class="{'on':v.myAnswer!='' && v.myAnswer!=[]}" @click="visit(index)">{{i+1}}</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="btns d-flex d-flex-middle d-flex-center" v-if="!readOnly">
      <el-button type="primary" size="small" class="baseBtn" v-if="shortTime">{{ shortTimeTxt }}后可以提交</el-button>
      <el-button type="primary" size="small" @click="submit" class="baseBtn" v-if="!shortTime">提交</el-button>
			<el-button size="small" @click="upload" class="baseBtnS" v-if="showUpload">上传主观题附件</el-button>
		</div>
		<div class="btns d-flex d-flex-middle d-flex-center" v-if="redo">
			<el-button size="small" type="primary" @click="redoFn" class="baseBtnS">重做</el-button>
		</div>
	</div>
</template>

<script>
import {quesMap} from '@/utils/enums'
	export default {
		name:"cardList",
		props:{
			list:{
				default:[]
			},
			readOnly: {
				default:false
			},
			redo:{
				default: false
			},
			check:{
				default:()=>{}
			},
			card_data:{
				default:()=>{}
			},
			e_status:{
				default:''
			},
			showAnswer:{
				default: false
			},
      showUpload:{
        default: false
      },
      shortTime: {
        default: ''
      },
      shortTimeTxt: {
        default: ''
      }
		},
		data() {
			return {
				quesMap,
			};
		},
		methods:{
			haveVal(data){
				var flag = true
				data.children.map(v=>{
					if(v.myAnswer == '' || v.myAnswer == []){
						flag = false
					}
				})
				return flag
			},
			haveValue(arr){
				return arr.some(v=>v != '')
			},
			setClass(id,score){
				var classTxt = ''
				if(this.check[id] != null){
					if(this.check[id] == 0){
						classTxt = 'error'
					}
					if(this.check[id] > 0 && this.check[id] < score ){
						classTxt = 'dimidiate'
					}
					if(this.check[id] == score){
						classTxt = 'right'
					}
				}
				return classTxt
			},
			close(){
				this.$emit('close')
			},
			visit(index){
				this.$emit('visit',index)
			},
			submit(){
				this.$emit('submit')
			},
			go(id){
				this.$emit('position',id)
			},
			upload(){
				this.$emit('upload')
			},
			redoFn(){
				this.$emit('redo')
			}
		}
	}
</script>

<style lang="scss">
.cardList{
	height: calc(100vh - 420px);
	font-size: 14px;
	p{
		margin: 0;
	}
	.content{
		height:calc(100% - 60px);
		width: 100%;
		box-sizing: border-box;
		padding:  10px;
		position: relative;
		&.readOnly{
			padding-bottom: 0;
		}
		.list{
			height: 100%;
			overflow-y: scroll;
			.title{
				height: 40px;
				line-height: 40px;
				width: 100%;
				font-size: 14px;
			}
			.div{
				display: inline-block;
				width: 24px;
				height: 24px;
				border: 1px solid #999;
				text-align: center;
				line-height: 24px;
				margin: 10px;
				border-radius: 50%;
				color: #999;
				&.on{
					background-color: $primary;
					color: #fff;
					border-color: $primary;
				}
				&.dimidiate{
					background: orange;
					border-color: orange;
					color: #fff;
				}
				&.error{
					background: red;
					border-color: red;
					color: #fff;
				}
				&.right{
					background: #3c0;
					border-color: #3c0;
					color: #fff;
				}
			}
		}
	}
	.btns{
		width: 100%;
		height: 60px;
		background: #fff;
		.uploadBtn{
			margin-left: 15px;
		}
	}
}
</style>